import { Pubblicazione, SectionVM } from 'civil-status/view-models/step-form';
import { ID_ALTRO_STATO } from 'shell/components/shared/foreign-state-list';
import { ID_ALTRO_COMUNE } from 'shell/components/shared/municipality-list';
import { DESCRIPTION_ITALIAN_NATION, ID_ITALIAN_NATION } from 'shell/constants/id-italian-nation';

export const transformerPubblicazioneList = (
  dataSectonsList?: Array<SectionVM>
): Array<Pubblicazione> | undefined => {
  if ((dataSectonsList || [])?.length === 0) {
    return undefined;
  }

  return dataSectonsList?.map((itemSection) => {
    const isOtherState = itemSection?.foreign?.state?.code === ID_ALTRO_STATO;
    const isOtherMunicipality =
      itemSection?.italian?.municipality?.code?.toString() === ID_ALTRO_COMUNE;

    return {
      key: {
        idPubblicazione: itemSection.idPubblicazione || undefined,
      },
      idComune: itemSection?.italian?.municipality?.code?.toString()
        ? itemSection?.italian?.municipality?.code
        : undefined,
      nomeComune: isOtherMunicipality
        ? itemSection.italian?.otherMunicipality || undefined
        : itemSection?.italian?.municipality?.description,
      idProvincia: itemSection?.italian?.municipality?.idProvince || undefined,
      siglaProvincia: itemSection?.italian?.municipality?.province || undefined,
      idNazione:
        itemSection?.isForeign || itemSection?.foreign?.state?.code
          ? itemSection?.foreign?.state?.code
            ? Number.parseInt(itemSection?.foreign?.state?.code, 10)
            : undefined
          : itemSection?.italian?.municipality?.description
          ? ID_ITALIAN_NATION
          : undefined,
      nomeNazione:
        itemSection?.isForeign || itemSection?.foreign?.state?.value
          ? isOtherState
            ? itemSection?.foreign?.otherState || undefined
            : itemSection?.foreign?.state?.value
          : itemSection?.italian?.municipality?.description
          ? DESCRIPTION_ITALIAN_NATION
          : undefined,
      anagraficaConsolato: itemSection.foreign?.consulate?.id?.toString() || undefined,
      nomeAnagraficaConsolato: itemSection.foreign?.consulate?.value || undefined,
      dataInizio: itemSection.dataStart ? itemSection.dataStart.toFormat('yyyy-MM-dd') : undefined,
      dataFine: itemSection.dataEnd ? itemSection.dataEnd.toFormat('yyyy-MM-dd') : undefined,
      codiceSezione: itemSection.codeSection || undefined,
      tipoSezione: itemSection?.typePersistence || undefined,
    } as Pubblicazione;
  });
};
